export default __webpack_public_path__ + "static/saifun-contact-eecd5c56b0246715c9aadb19bcbd3ed7.jpeg";